import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import ErrorBoundaryFallback from './ErrorBoundaryFallback';

export default function ErrorBoundary({ children, title, message, compact = false }) {
  return (
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <ErrorBoundaryFallback
          title={title}
          message={message}
          onReset={resetError}
          compact={compact}
        />
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
}
